import { render, staticRenderFns } from "./AddSchedule.vue?vue&type=template&id=f958f24c&scoped=true"
import script from "./AddSchedule.vue?vue&type=script&lang=js"
export * from "./AddSchedule.vue?vue&type=script&lang=js"
import style0 from "./AddSchedule.vue?vue&type=style&index=0&id=f958f24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f958f24c",
  null
  
)

export default component.exports